module.exports = __webpack_public_path__ + "media/serviceDropDown/arrow-3ca2af63.png";